/**
 * @file        src/lib/isoCountries.js
 * @description Client mirror of admin_backend/src/utils/isoCountries.js — the
 *              ISO-3166-1 alpha-2 register the airport form checks a country
 *              code against, so a bad code is caught before the round trip.
 *
 *              A COPY, not an import: admin_frontend and admin_backend are
 *              separate builds. Must stay byte-identical to the backend list;
 *              a code missing here but present there would block a country the
 *              server would have accepted. ISO-3166 alpha-2 changes roughly
 *              once a decade; when it does, change this, the backend util, and
 *              booking_backend/utils/isoCountries.js together.
 * @author      Kinetika Labs
 * @created     2026-09-15
 * @changelog
 *   - 2026-09-15 Claude — Initial.
 */

// prettier-ignore
export const ALPHA2 = [
  'AD','AE','AF','AG','AI','AL','AM','AO','AQ','AR','AS','AT','AU','AW','AX','AZ',
  'BA','BB','BD','BE','BF','BG','BH','BI','BJ','BL','BM','BN','BO','BQ','BR','BS',
  'BT','BW','BY','BZ','CA','CC','CD','CF','CG','CH','CI','CK','CL','CM','CN','CO',
  'CR','CU','CV','CW','CX','CY','CZ','DE','DJ','DK','DM','DO','DZ','EC','EE','EG',
  'EH','ER','ES','ET','FI','FJ','FK','FM','FO','FR','GA','GB','GD','GE','GF','GG',
  'GH','GI','GL','GM','GN','GP','GQ','GR','GS','GT','GU','GW','GY','HK','HN','HR',
  'HT','HU','ID','IE','IL','IM','IN','IO','IQ','IR','IS','IT','JE','JM','JO','JP',
  'KE','KG','KH','KI','KM','KN','KP','KR','KW','KY','KZ','LA','LB','LC','LI','LK',
  'LR','LS','LT','LU','LV','LY','MA','MC','MD','ME','MF','MG','MH','MK','ML','MM',
  'MN','MO','MP','MQ','MR','MS','MT','MU','MV','MW','MX','MY','MZ','NA','NC','NE',
  'NF','NG','NI','NL','NO','NP','NR','NU','NZ','OM','PA','PE','PF','PG','PH','PK',
  'PL','PM','PN','PR','PS','PT','PW','PY','QA','RE','RO','RS','RU','RW','SA','SB',
  'SC','SD','SE','SG','SH','SI','SJ','SK','SL','SM','SN','SO','SR','SS','ST','SV',
  'SX','SY','SZ','TC','TD','TF','TG','TH','TJ','TK','TL','TM','TN','TO','TR','TT',
  'TV','TW','TZ','UA','UG','UM','US','UY','UZ','VA','VC','VE','VG','VI','VN','VU',
  'WF','WS','YE','YT','ZA','ZM','ZW',
];

const KNOWN = new Set(ALPHA2);

/** Is this a real ISO-3166-1 alpha-2 code? Case-insensitive. */
export function isIsoCode(code) {
  return KNOWN.has(String(code || '').trim().toUpperCase());
}
